'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

exports.deepEqual = function (a, b) {
  var propsA = Object.getOwnPropertyNames(a);
  var propsB = Object.getOwnPropertyNames(b);
  if (propsA.length !== propsB.length) return false;

  for (var i = 0; i < propsA.length; i++) {
    var prop = propsA[i];
    if (a[prop] !== b[prop]) return false;
  }

  return true;
};

var OperationTuple3 = /*#__PURE__*/function () {
  function OperationTuple3(value, added, removed) {
    _classCallCheck(this, OperationTuple3);

    this.value = value;
    this.added = new Set(added);
    this.removed = new Set(removed);
  }

  _createClass(OperationTuple3, null, [{
    key: "create",
    value: function create(value, added, removed) {
      return new OperationTuple3(value, added, removed);
    }
  }, {
    key: "from",
    value: function from(json) {
      return OperationTuple3.create(json.value, json.added, json.removed);
    }
  }]);

  return OperationTuple3;
}();

exports.OperationTuple3 = OperationTuple3;